export default "__VITE_ASSET__af1fe4fa__"